import { useContext, useEffect, useState } from "react";
import { GET_ALL_DESI_MOVIES, fetchData } from "../../../components/Service";
import { Link } from "../../../../node_modules/react-router-dom/dist/index";
import { Context } from "../../../components/Context";
import _ from "lodash";

const DesiPage = () => {
	const [list, setList] = useState([]);
	const [context] = useContext(Context);

	const getList = (country_id, state_id) => {
		let payload = {
			country_id: country_id,
			state_id: state_id,
		};

		fetchData(GET_ALL_DESI_MOVIES, "POST", payload, false, false, (res) => {
			if (res.status) {
				setList(res?.data?.data);
			} else {
				console.log(res);
			}
		});
	};

	useEffect(() => {
		if (context?.countryId && context?.stateId) {
			getList(context?.countryId, context?.stateId);
		}
	}, [context]);
	return (
		<>
			<div className="card">
				<div className="card-header d-flex align-items-center justify-content-between mb-0 usa-bg py-1">
					<div className="national-bg">
						<h6 className="text-white d-flex ind1">Desi Movies</h6>
					</div>
					<Link to={`/desi-page`} className="text-white align-middle font13 d-flex align-items-center position-relative">
						View <i className="fi fi-rr-arrow-small-right text-white linehight0 ms-1"></i>
					</Link>
				</div>
				<div className="card-body p-1">
					<div className="row d-flex align-items-center">
						{list?.slice(0, 4)?.map((item) => (
							<div key={item.id} className="col-3 event_n mb-1">
								<div className="card-grid-2 hover-up h-100 mb-0">
									<Link to={`/desi-page/${item.id}`} style={{ height: "26px" }}>
										<div className="ne-img">
											<img src={item.image} alt="..." />
										</div>
									</Link>
									<div className="card-block-info position-relative">
										<h6>
											<Link to={`/desi-page/${item.id}`} style={{ height: "26px" }}>
												{_.truncate(item.name, { length: 20 })}
											</Link>
										</h6>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	);
};

export default DesiPage;
